import React from 'react';
import { Link } from 'react-router-dom';

// Simple header for pages that don't require authentication
// Shows only logo on the left that links to home page
const SimpleHeader = () => {
  return (
    <header className="simple-header">
      <div className="container">
        <div className="simple-header-content">
          {/* Mobile: logo */}
          <Link to="/" className="simple-header-logo-mobile" aria-label="Home">
            <img src="/logobg.png" alt="getphotoshoot.ai" className="brand-logo" />
          </Link>

          {/* Desktop: logo with text */}
          <Link to="/" className="simple-header-logo-desktop" aria-label="Home">
            <img src="/logobg.png" alt="getphotoshoot.ai" className="brand-logo-desktop" />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default SimpleHeader;

